import React, { useState, useEffect } from "react";
import "./app.css";

const API = "http://localhost:4000/api";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [view, setView] = useState(token ? "dashboard" : "auth");
  const [login, setLogin] = useState({ email: "", password: "" });
  const [org, setOrg] = useState({
    name: "",
    adminEmail: "",
    adminPassword: ""
  });

  const [employees, setEmployees] = useState([]);
  const [teams, setTeams] = useState([]);
  const [empForm, setEmpForm] = useState({ name: "", role: "", email: "" });
  const [teamForm, setTeamForm] = useState({ name: "" });

  async function api(path, method = "GET", body) {
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = "Bearer " + token;

    const res = await fetch(API + path, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined
    });

    return res.json();
  }

  async function loadAll() {
    setEmployees(await api("/employees"));
    setTeams(await api("/teams"));
  }

  useEffect(() => {
    if (view === "dashboard") loadAll();
  }, [view]);

  async function loginSubmit(e) {
    e.preventDefault();
    const res = await api("/login", "POST", login);
    if (res.token) {
      localStorage.setItem("token", res.token);
      setToken(res.token);
      setView("dashboard");
    }
  }

  async function orgSubmit(e) {
    e.preventDefault();
    const res = await api("/org", "POST", org);
    if (res.token) {
      localStorage.setItem("token", res.token);
      setToken(res.token);
      setView("dashboard");
    }
  }

  async function addEmployee(e) {
    e.preventDefault();
    await api("/employees", "POST", empForm);
    setEmpForm({ name: "", role: "", email: "" });
    loadAll();
  }

  async function addTeam(e) {
    e.preventDefault();
    await api("/teams", "POST", teamForm);
    setTeamForm({ name: "" });
    loadAll();
  }

  async function assign(teamId, employeeId) {
    await api(`/teams/${teamId}/assign`, "POST", { employeeId });
    loadAll();
  }

  if (view === "auth") {
    return (
      <div style={{ padding: 20 }}>
        <h2>Create Organization</h2>
        <form onSubmit={orgSubmit}>
          <input placeholder="Org name"
            value={org.name}
            onChange={(e) => setOrg({ ...org, name: e.target.value })}
          />
          <br />
          <input placeholder="Admin email"
            value={org.adminEmail}
            onChange={(e) => setOrg({ ...org, adminEmail: e.target.value })}
          />
          <br />
          <input
            placeholder="Admin password"
            type="password"
            value={org.adminPassword}
            onChange={(e) =>
              setOrg({ ...org, adminPassword: e.target.value })
            }
          />
          <button>Create</button>
        </form>

        <h3>Or Login</h3>
        <form onSubmit={loginSubmit}>
          <input
            placeholder="Email"
            value={login.email}
            onChange={(e) => setLogin({ ...login, email: e.target.value })}
          />
          <br />
          <input
            placeholder="Password"
            type="password"
            value={login.password}
            onChange={(e) => setLogin({ ...login, password: e.target.value })}
          />
          <button>Login</button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Dashboard</h2>
      <button
        onClick={() => {
          localStorage.removeItem("token");
          setToken("");
          setView("auth");
        }}
      >
        Logout
      </button>

      <hr />

      <h3>Add Employee</h3>
      <form onSubmit={addEmployee}>
        <input
          placeholder="Name"
          value={empForm.name}
          onChange={(e) => setEmpForm({ ...empForm, name: e.target.value })}
        />
        <input
          placeholder="Role"
          value={empForm.role}
          onChange={(e) => setEmpForm({ ...empForm, role: e.target.value })}
        />
        <input
          placeholder="Email"
          value={empForm.email}
          onChange={(e) => setEmpForm({ ...empForm, email: e.target.value })}
        />
        <button>Add</button>
      </form>

      <h3>Add Team</h3>
      <form onSubmit={addTeam}>
        <input
          placeholder="Team name"
          value={teamForm.name}
          onChange={(e) => setTeamForm({ ...teamForm, name: e.target.value })}
        />
        <button>Add</button>
      </form>

      <h3>Employees</h3>
      <ul>
        {employees.map((e) => (
          <li key={e.id}>{e.name}</li>
        ))}
      </ul>

      <h3>Teams</h3>
      {teams.map((t) => (
        <div key={t.id} style={{ padding: 10, border: "1px solid #ddd" }}>
          <strong>{t.name}</strong>
          <ul>
            {(t.Employees || []).map((emp) => (
              <li key={emp.id}>{emp.name}</li>
            ))}
          </ul>

          <select id={`team-${t.id}`}>
            <option value="">Select employee</option>
            {employees.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => {
              const empId = document.getElementById(`team-${t.id}`).value;
              if (empId) assign(t.id, empId);
            }}
          >
            Assign
          </button>
        </div>
      ))}
    </div>
  );
}

export default App;
